/* =========================================================
   Sports n deco — Rendu LIVE affiche col (navigateur)
   Produit exactement le même visuel que les images catalogue,
   à partir d'un data-map compact pré-projeté (cols-output/live/<slug>.json).
   API :
     SNColPoster.render(mapData, opts) -> string SVG
     SNColPoster.PALETTES -> { id: {label, ...couleurs} }
   opts : { palette, title, side, region, km, dplus, pct, alt, perso }
   (les valeurs par défaut viennent de mapData.col)
   ========================================================= */

(function () {
  const PALETTES = {
    blanc:  { label:'Blanc',  pageBg:'#ffffff', mapBg:'#f7f8f9', border:'#e6eaee',
              rMajor:'#6d737b', rMedium:'#9aa0a7', rMinor:'#b4b9bf',
              track:'#0B2D5B', halo:'#ffffff', ink:'#0B2D5B', muted:'#8891a0', accent:'#FF6B2C',
              startF:'#ffffff', startS:'#0B2D5B', endF:'#FF6B2C', endS:'#ffffff' },
    mono:   { label:'Noir & blanc', pageBg:'#ffffff', mapBg:'#f4f4f4', border:'#e2e2e2',
              rMajor:'#8a8a8a', rMedium:'#b2b2b2', rMinor:'#cfcfcf',
              track:'#111111', halo:'#ffffff', ink:'#111111', muted:'#8a8a8a', accent:'#111111',
              startF:'#ffffff', startS:'#111111', endF:'#111111', endS:'#ffffff' },
    nuit:   { label:'Nuit',   pageBg:'#0B2D5B', mapBg:'#0e335f', border:'#1c4577',
              rMajor:'#5f7aa0', rMedium:'#4a6aa8', rMinor:'#385584',
              track:'#FF6B2C', halo:'#0B2D5B', ink:'#ffffff', muted:'#9fb2ce', accent:'#FF6B2C',
              startF:'#0B2D5B', startS:'#ffffff', endF:'#FF6B2C', endS:'#0B2D5B' },
    encre:  { label:'Encre',  pageBg:'#0E0E10', mapBg:'#17171a', border:'#2a2a2e',
              rMajor:'#5a5a60', rMedium:'#444448', rMinor:'#333337',
              track:'#FF6B2C', halo:'#0E0E10', ink:'#ffffff', muted:'#8a8a90', accent:'#FF6B2C',
              startF:'#0E0E10', startS:'#ffffff', endF:'#FF6B2C', endS:'#0E0E10' },
    kraft:  { label:'Kraft',  pageBg:'#efe7d6', mapBg:'#e7ddc7', border:'#d2c6a8',
              rMajor:'#8a7a58', rMedium:'#a89874', rMinor:'#b8ac8c',
              track:'#7b3f00', halo:'#efe7d6', ink:'#3A2C12', muted:'#8a7a58', accent:'#c2410c',
              startF:'#efe7d6', startS:'#3A2C12', endF:'#c2410c', endS:'#efe7d6' },
    sauge:  { label:'Sauge',  pageBg:'#e9f0eb', mapBg:'#dde8e0', border:'#c3d4c8',
              rMajor:'#6f8a79', rMedium:'#8fa89a', rMinor:'#a7bcb0',
              track:'#24402F', halo:'#e9f0eb', ink:'#24402F', muted:'#6f8a79', accent:'#2f7d54',
              startF:'#e9f0eb', startS:'#24402F', endF:'#2f7d54', endS:'#e9f0eb' },
    ardoise:{ label:'Ardoise', pageBg:'#26303a', mapBg:'#2c3742', border:'#3b4855',
              rMajor:'#5a6b78', rMedium:'#47555f', rMinor:'#3a464f',
              track:'#e8b04b', halo:'#26303a', ink:'#f2f5f7', muted:'#9fb0bd', accent:'#e8b04b',
              startF:'#26303a', startS:'#f2f5f7', endF:'#e8b04b', endS:'#26303a' },
    bordeaux:{ label:'Bordeaux', pageBg:'#f4ede7', mapBg:'#ece1d8', border:'#dccabd',
              rMajor:'#a68f80', rMedium:'#c1ab9c', rMinor:'#d1beaf',
              track:'#7d1f2e', halo:'#f4ede7', ink:'#45131c', muted:'#9a7f70', accent:'#9c2233',
              startF:'#f4ede7', startS:'#45131c', endF:'#9c2233', endS:'#f4ede7' },
  };

  // Rampe de pente PROPRE À CHAQUE PALETTE (coloriste par palette, contraste WCAG validé) :
  // soft = pente douce, hard = pente forte (plus dense/foncé = plus dur), descent = neutre discret.
  const PROF = {
    blanc:   { soft:'#d5e0ef', hard:'#0B2D5B', descent:'#ccd2da' },
    mono:    { soft:'#cbd0d6', hard:'#22262e', descent:'#cfcfcf' },
    nuit:    { soft:'#6e4326', hard:'#FF8E48', descent:'#6d84a8' },
    encre:   { soft:'#7a4227', hard:'#FF7A3D', descent:'#5c5c64' },
    kraft:   { soft:'#dcc59a', hard:'#8a3809', descent:'#b0a584' },
    sauge:   { soft:'#c6dacc', hard:'#274430', descent:'#b7c9bc' },
    ardoise: { soft:'#6e5a30', hard:'#e8b04b', descent:'#74818e' },
    bordeaux:{ soft:'#e3bfb0', hard:'#7d1f2e', descent:'#c9b6a9' },
  };
  Object.keys(PROF).forEach(k => { if (PALETTES[k]) PALETTES[k].prof = PROF[k]; });

  function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }
  function frNum(n){ return Number(n).toLocaleString('fr-FR'); }
  // ---- couleurs : rampe de pente dérivée / propre à la palette ----
  function hexRgb(h){ h=String(h).replace('#',''); if(h.length===3) h=h[0]+h[0]+h[1]+h[1]+h[2]+h[2]; return [parseInt(h.slice(0,2),16),parseInt(h.slice(2,4),16),parseInt(h.slice(4,6),16)]; }
  function mixHex(a,b,t){ const A=hexRgb(a),B=hexRgb(b); return '#'+[0,1,2].map(i=>Math.max(0,Math.min(255,Math.round(A[i]+(B[i]-A[i])*t))).toString(16).padStart(2,'0')).join(''); }
  function lum(hex){ const [r,g,b]=hexRgb(hex).map(v=>{v/=255; return v<=0.03928?v/12.92:Math.pow((v+0.055)/1.055,2.4);}); return 0.2126*r+0.7152*g+0.0722*b; }
  const isDark = hex => lum(hex) < 0.18;
  // rampe = { soft (pente douce), hard (pente forte), descent (neutre) } ; p.prof si fourni, sinon dérivée
  function rampFor(p){
    if (p.prof) return p.prof;
    return isDark(p.pageBg)
      ? { soft: mixHex(p.pageBg, p.accent, 0.45), hard: p.accent, descent: mixHex(p.pageBg, p.muted, 0.55) }
      : { soft: mixHex(p.pageBg, p.track, 0.26), hard: p.track,   descent: mixHex(p.pageBg, p.muted, 0.72) };
  }
  function checkerBand(x, y, w, cell, rows, color){
    const cols = Math.round(w/cell), cw = w/cols; let s='';
    for(let r=0;r<rows;r++) for(let c=0;c<cols;c++) if((r+c)%2===0)
      s += `<rect x="${(x+c*cw).toFixed(1)}" y="${(y+r*cell).toFixed(1)}" width="${(cw+0.6).toFixed(1)}" height="${cell}" fill="${color}"/>`;
    return s;
  }

  function render(md, opts) {
    opts = opts || {};
    const c = md.col || {};
    const p = PALETTES[opts.palette] || PALETTES.blanc;
    const [PW, PH] = md.viewBox;
    const [MX, MT, mapW] = md.map; // MX/MT/mapW identiques carte pleine/courte
    // mode profil altimétrique : carte plus courte + bande profil (si data dispo)
    const showProfile = opts.showProfile && md.profile;
    const mapHnow = (showProfile && md.mapS) ? md.mapS[3] : md.map[3];
    const Atrack = (showProfile && md.trackS != null) ? md.trackS : md.track;
    const Aroads = (showProfile && md.roadsS) ? md.roadsS : md.roads;
    const Astart = (showProfile && md.startS) ? md.startS : md.start;
    const Aend   = (showProfile && md.endS)   ? md.endS   : md.end;

    const title  = ((opts.title  != null ? opts.title  : c.name) || '').toUpperCase();
    const side   = ((opts.side   != null ? opts.side   : c.side) || '').toUpperCase();
    const region = ((opts.region != null ? opts.region : c.region) || '').toUpperCase();
    const country = (c.country || '').toUpperCase();
    // eyebrow : "DEPUIS X" pour un col, sinon libellé libre (sortie importée)
    const eyebrow = c.eyebrow ? String(c.eyebrow).toUpperCase() : (side ? 'DEPUIS ' + side : 'MON ASCENSION');
    // ligne région · pays (parties non vides)
    const regionLine = [region, country].filter(Boolean).join(' · ');
    const km    = opts.km    != null ? opts.km    : c.km;
    const dplus = opts.dplus != null ? opts.dplus : c.dplus;
    const pct   = opts.pct   != null ? opts.pct   : c.pct;
    const alt   = opts.alt   != null ? opts.alt   : c.alt;
    const perso = (opts.perso || '').trim();
    const chrono = (opts.chrono || '').trim();
    const showStats = opts.showStats !== false; // défaut : affiché
    const showCoord = opts.showCoord !== false; // défaut : affiché
    const coordLabel = (c.lat != null) ? `${(+c.lat).toFixed(3)}°N · ${(+c.lon).toFixed(3)}°E` : '';

    const titleSize = title.length > 16 ? 46 : 54;
    const by = MT + md.map[3]; // texte calé sur la carte PLEINE (inchangé en mode profil)

    // bande profil altimétrique COLORÉE PAR PENTE (sous la carte courte)
    let profileSvg = '';
    if (showProfile) {
      const pr = md.profile, bx = MX, bw = mapW, bTop = MT + mapHnow + 24, bH = 100, bBot = bTop + bH;
      const pts = pr.pts, eMinP = pr.eMin, eMaxP = pr.eMax, totalKm = pr.km;
      const fx = f => bx + f*bw, fy = e => bBot - ((e - eMinP)/((eMaxP - eMinP)||1))*bH;
      // altitude interpolée à une fraction f (0→1) le long du tracé
      const eleAt = f => {
        if (f <= pts[0][0]) return pts[0][1];
        for (let i=1;i<pts.length;i++){ if (pts[i][0] >= f){ const a=pts[i-1], b=pts[i], t=(f-a[0])/((b[0]-a[0])||1); return a[1]+(b[1]-a[1])*t; } }
        return pts[pts.length-1][1];
      };
      // barres régulières → couleur = pente moyenne du tronçon (anti-bruit SRTM)
      const N = 40; let binE = []; for(let k=0;k<=N;k++) binE.push(eleAt(k/N));
      binE = binE.map((v,i)=> (binE[i-1]==null?v:binE[i-1])*0.25 + v*0.5 + (binE[i+1]==null?v:binE[i+1])*0.25);
      const segLen = totalKm*1000/N;
      const grd = k => (binE[k+1]-binE[k])/segLen*100;
      // rampe de pente PROPRE À LA PALETTE : couleur continue (plus dense = plus dur), descente neutre
      const ramp = rampFor(p), GMAX = 13, smooth = t => t*t*(3-2*t);
      const gcol = g => { if (g < -1) return ramp.descent; const t = Math.min(Math.abs(g)/GMAX, 1); return mixHex(ramp.soft, ramp.hard, smooth(t)); };
      let segs='', maxG=0;
      for(let k=0;k<N;k++){ const x1=fx(k/N),x2=fx((k+1)/N),y1=fy(binE[k]),y2=fy(binE[k+1]), g=grd(k);
        if(Math.abs(g)>maxG) maxG=Math.abs(g);
        segs += `<path d="M${x1.toFixed(1)} ${bBot.toFixed(1)} L${x1.toFixed(1)} ${y1.toFixed(1)} L${x2.toFixed(1)} ${y2.toFixed(1)} L${x2.toFixed(1)} ${bBot.toFixed(1)} Z" fill="${gcol(g)}"/>`; }
      const crest = 'M'+binE.map((e,k)=>fx(k/N).toFixed(1)+' '+fy(e).toFixed(1)).join(' L');
      // axe des distances (km) sous la ligne de base — cale sur la distance officielle si connue
      let axisKm = (typeof km === 'number' && km > 0) ? km : totalKm;
      if (axisKm === totalKm && c.kind === 'race' && Array.isArray(c.stats) && c.stats[0]) {
        const s = String(c.stats[0][0]), m = s.match(/([\d]+(?:[.,][\d]+)?)/);
        if (m && /km/i.test(s)) { const v = parseFloat(m[1].replace(',','.')); if (v > 0 && v >= totalKm*0.5 && v <= totalKm*2) axisKm = v; }
      }
      const nice = t => { const S=[1,2,5,10,20,25,50,100,200]; const tgt=t/5; for(const s of S) if(s>=tgt) return s; return 500; };
      const step = nice(axisKm);
      const tickTxt = (x,label,anchor) => `<text x="${x.toFixed(1)}" y="${(bBot+15).toFixed(0)}" font-size="9.5" fill="${p.muted}" text-anchor="${anchor}">${label}</text>`;
      const tickMk  = x => `<line x1="${x.toFixed(1)}" y1="${bBot.toFixed(1)}" x2="${x.toFixed(1)}" y2="${(bBot+4).toFixed(1)}" stroke="${p.border}" stroke-width="1"/>`;
      let axis = tickTxt(bx,'0','start');
      for(let d=step; d < axisKm*0.94; d+=step){ const x=fx(d/axisKm); axis += tickMk(x) + tickTxt(x, String(Math.round(d)), 'middle'); }
      const totLbl = (Math.abs(axisKm-Math.round(axisKm)) < 0.1 ? String(Math.round(axisKm)) : axisKm.toFixed(1).replace('.',',')) + ' km';
      axis += tickMk(fx(1)) + tickTxt(fx(1), totLbl, 'end');
      // légende : 4 seuils de pente, EN COULEURS DE LA RAMPE (haut droite)
      const legVals = [['4 %',4],['7 %',7],['10 %',10],['13 %+',13]];
      let legSvg=''; let lx = bx+bw;
      for(let i=legVals.length-1;i>=0;i--){ const cc = mixHex(ramp.soft, ramp.hard, smooth(Math.min(legVals[i][1]/GMAX,1)));
        legSvg = `<rect x="${(lx-13).toFixed(0)}" y="${(bTop-18).toFixed(0)}" width="9" height="9" rx="1.5" fill="${cc}" stroke="${p.border}" stroke-width="0.6"/><text x="${(lx-16).toFixed(0)}" y="${(bTop-10).toFixed(0)}" font-size="10" fill="${p.muted}" text-anchor="end">${legVals[i][0]}</text>` + legSvg; lx -= 54; }
      profileSvg =
        /* Demi-cadratin, pas la flèche U+2192 : absente de Sora, elle sort en
           tofu partout où resvg rend — image catalogue ET fichier d'impression. */
        `<text x="${bx}" y="${(bTop-9).toFixed(0)}" font-size="11" font-weight="700" fill="${p.muted}" letter-spacing="1.5">PROFIL · ${frNum(eMinP)}–${frNum(eMaxP)} M · PENTE MAX ${Math.round(maxG)} %</text>`
      + legSvg + segs
      + `<path d="${crest}" fill="none" stroke="${p.ink}" stroke-width="1.2" stroke-linejoin="round" opacity="0.28"/>`
      + `<line x1="${bx}" y1="${bBot.toFixed(1)}" x2="${(bx+bw).toFixed(1)}" y2="${bBot.toFixed(1)}" stroke="${p.border}" stroke-width="1.2"/>`
      + axis
      + `<circle cx="${fx(1).toFixed(1)}" cy="${fy(binE[N]).toFixed(1)}" r="4" fill="${p.accent}"/>`;
    }

    // grille de stats (masquable)
    const statsCells = (c.kind === 'race' && Array.isArray(c.stats)) ? c.stats : [
      [String(km).replace('.',',')+' km','DISTANCE'],
      [frNum(dplus)+' m','DÉNIVELÉ +'],
      [String(pct).replace('.',',')+' %','PENTE MOY'],
      [frNum(alt)+' m','ALTITUDE'],
    ];
    const statsSvg = showStats ? `<g font-size="13" fill="${p.muted}">${ statsCells.slice(0,4).map((cell,i)=>{
      const xs=[MX, MX+185, MX+370, PW-MX], anchor = i===3 ? ' text-anchor="end"' : '';
      return `<text x="${xs[i]}" y="${by+214}" font-weight="700" fill="${p.ink}" font-size="23"${anchor}>${esc(cell[0])}</text>`
           + `<text x="${xs[i]}" y="${by+236}" letter-spacing="1.5"${anchor}>${esc(cell[1])}</text>`;
    }).join('') }</g>` : '';

    // bloc bas : DUO (2 colonnes prénom + chrono) OU solo (chrono + dédicace centrés)
    const duo = opts.duo && [opts.duo.n1, opts.duo.t1, opts.duo.n2, opts.duo.t2].some(v => String(v || '').trim());
    let bottomSvg = '';
    if (duo) {
      const d = opts.duo, lX = MX + mapW * 0.25, rX = MX + mapW * 0.75, cX = PW / 2;
      const colTxt = (x, name, time) =>
          (String(name || '').trim() ? `<text x="${x.toFixed(0)}" y="${by+298}" font-size="18" font-weight="600" fill="${p.ink}" text-anchor="middle" letter-spacing="0.5">${esc(String(name).trim())}</text>` : '')
        + (String(time || '').trim() ? `<text x="${x.toFixed(0)}" y="${by+330}" font-size="25" font-weight="700" fill="${p.accent}" text-anchor="middle" letter-spacing="1">${esc(String(time).trim())}</text>` : '');
      bottomSvg =
          `<line x1="${MX}" y1="${by+264}" x2="${PW-MX}" y2="${by+264}" stroke="${p.border}" stroke-width="1.5"/>`
        + `<line x1="${cX}" y1="${by+280}" x2="${cX}" y2="${by+340}" stroke="${p.border}" stroke-width="1.2"/>`
        + `<circle cx="${cX}" cy="${by+311}" r="14" fill="${p.pageBg}"/>`
        + `<text x="${cX}" y="${by+317}" font-size="18" font-weight="700" fill="${p.accent}" text-anchor="middle">&amp;</text>`
        + colTxt(lX, d.n1, d.t1) + colTxt(rX, d.n2, d.t2);
    } else {
      const bl = [];
      if (chrono) bl.push([chrono.toUpperCase(), p.accent, 700, 19, '2']);
      if (perso)  bl.push([perso.toUpperCase(), p.ink,    600, 16, '1.5']);
      bottomSvg = bl.length
        ? `<line x1="${MX}" y1="${by+264}" x2="${PW-MX}" y2="${by+264}" stroke="${p.border}" stroke-width="1.5"/>`
          + bl.map((l,i)=>`<text x="${PW/2}" y="${by+294 + i*26}" font-size="${l[3]}" font-weight="${l[2]}" fill="${l[1]}" text-anchor="middle" letter-spacing="${l[4]}">${esc(l[0])}</text>`).join('')
        : '';
    }

    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${PW} ${PH}" font-family="'Sora','Inter',sans-serif">
<rect width="${PW}" height="${PH}" fill="${p.pageBg}"/>
<clipPath id="snmc"><rect x="${MX}" y="${MT}" width="${mapW}" height="${mapHnow}" rx="2"/></clipPath>
<g clip-path="url(#snmc)">
  <rect x="${MX}" y="${MT}" width="${mapW}" height="${mapHnow}" fill="${p.mapBg}"/>
  <path d="${Aroads.minor}"  fill="none" stroke="${p.rMinor}"  stroke-width="1.0" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="${Aroads.medium}" fill="none" stroke="${p.rMedium}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="${Aroads.major}"  fill="none" stroke="${p.rMajor}"  stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="${Atrack}" fill="none" stroke="${p.halo}"  stroke-width="7"   stroke-linecap="round" stroke-linejoin="round" opacity="0.9"/>
  <path d="${Atrack}" fill="none" stroke="${p.track}" stroke-width="4.5" stroke-linecap="round" stroke-linejoin="round"/>
  <circle cx="${Astart[0]}" cy="${Astart[1]}" r="6" fill="${p.startF}" stroke="${p.startS}" stroke-width="3"/>
  <circle cx="${Aend[0]}"   cy="${Aend[1]}"   r="7" fill="${p.endF}"   stroke="${p.endS}"   stroke-width="2.5"/>
</g>
<rect x="${MX}" y="${MT}" width="${mapW}" height="${mapHnow}" rx="2" fill="none" stroke="${p.border}" stroke-width="1.5"/>
${profileSvg}
${ showCoord && coordLabel ? `<text x="${MX}" y="${by+40}" font-size="14" font-weight="700" fill="${p.ink}" letter-spacing="1">${esc(coordLabel)}</text>` : '' }
<text x="${PW-MX}" y="${by+40}" font-size="13" fill="${p.muted}" text-anchor="end" letter-spacing="1">${esc(regionLine)}</text>
<line x1="${MX}" y1="${by+58}" x2="${PW-MX}" y2="${by+58}" stroke="${p.border}" stroke-width="1.5"/>
<text x="${MX}" y="${by+118}" font-size="17" font-weight="600" fill="${p.accent}" letter-spacing="3">${esc(eyebrow)}</text>
<text x="${MX}" y="${by+170}" font-size="${titleSize}" font-weight="800" fill="${p.ink}" letter-spacing="-1.5">${esc(title)}</text>
${statsSvg}
${bottomSvg}
${ c.motif === 'checker' ? checkerBand(MX, PH-16, PW-2*MX, 7, 2, p.ink) : '' }
</svg>`;
  }

  window.SNColPoster = { render, PALETTES };
})();
